import { IconProps } from "./types";

export default function TelegramIcon({
  className,
  width = 20,
  height = 20,
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 240 240"
      fill="currentColor"
      className={className}
      width={width}
      height={height}
    >
      <defs>
        <linearGradient
          id="A"
          x1="46.136"
          x2="28.836"
          y1="11.536"
          y2="51.9"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#37aee2" offset="0" />
          <stop stop-color="#1e96c8" offset="1" />
        </linearGradient>
      </defs>
      <g transform="matrix(3.468208 0 0 3.468208 0 -.00001)">
        <circle cy="34.6" cx="34.6" r="34.6" fill="url(#A)" />
        <path
          d="M14.4 34.3l23.3-9.6c2.3-1 10.1-4.2 10.1-4.2s3.6-1.4 3.3 2c-.1 1.4-.9 6.3-1.7 11.6l-2.5 15.7s-.2 2.3-1.9 2.7-4.5-1.4-5-1.8c-.4-.3-7.5-4.8-10.1-7-.7-.6-1.5-1.8.1-3.2 3.6-3.3 7.9-7.4 10.5-10 1.2-1.2 2.4-4-2.6-.6l-14.1 9.5s-1.6 1-4.6.1-6.5-2.1-6.5-2.1-2.4-1.5 1.7-3.1z"
          fill="#fff"
        />
      </g>
    </svg>
  );
}
